export default "__VITE_ASSET__cboNTefl__"